import React, { Component } from "react";
import "./index.scss";
import { GenerateAtribute } from "../../@utils/generate-atribute";

export class GalerySideSlider extends Component {
  static defaultProps = {
    dismiss: null,
    show: null,
  };
  mainRef = React.createRef().current;
  constructor(props) {
    super(props);
    this.state = {
      pos: 0,
      width: props.galery.length,
    };
  }

  getElementConfig = (props) => {
    const res = GenerateAtribute(props);
    return res;
  };

  componentDidMount = () => {
    this.setState({ photos: this.props.galery }, () => {
      this.init();
    });
  };

  _timerCount = null;
  init = () => {
    if (this.mainRef) {
      clearTimeout(this._timerCount);
      this._timerCount = setTimeout(this.setSlide, 1000);
    }
  };

  _counter = 0;
  setSlide = () => {
    let width = this.state.width || 0;
    if (this.mainRef) {
      //
      const itemWidth = 50 * width;
      // const itemWidth = total / width;
      const image = this.mainRef.querySelector(`#IMAGE_BOX_${this._counter}`);
      if (image) {
        const newImage = image.cloneNode(true);
        newImage.style.left = `${itemWidth}%`;
        this.mainRef.append(newImage);
        newImage.setAttribute("id", `IMAGE_BOX_${width}`);
        setTimeout(() => image.remove(), 1000);
      }
      width += 1;
      this._counter += 1;
      this.setState({ pos: this._counter, width }, () => {
        this.init();
      });
    }
  };

  render() {
    const { props, state } = this;
    const photos = props.galery || [];
    const total = 50 * state.width;
    const itemWidth = total / state.width;
    // const limit =

    const style = {
      // opacity: "1",
      // transform: "scale(1.2)",
      marginLeft: `${state.pos * -itemWidth}%`,
      width: `${100}%`,
    };

    const styleImage = {
      width: `${itemWidth}%`,
    };

    // console.log(state.photos);

    return (
      <section style={{ width: "100%" }} {...this.getElementConfig(props)} className={`fox_backgroud_slider_side ${props.className}`}>
        <div className="slider_wrapper">
          <div className="slider_inside" style={style} ref={(ref) => (this.mainRef = ref)}>
            {photos.map((item, i) => (
              <div className="image_box" id={`IMAGE_BOX_${i}`} style={{ ...styleImage, left: `${i * itemWidth}%` }}>
                <img src={item.src} alt="" className={`slider_image${i}`} key={i} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}
